import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  dailyChart: {
    boxShadow: 'none',
    width: '100%',
    '& > div': {
      '& path:last-of-type': {
        strokeDasharray: '1',
      },
    },
    // marginTop: '10px',
  },
  isLoading: {
    color: colors.lightGray,
  },
  subTitle: {
    fontSize: '0.875rem',
    fontHeight: 'bold',
    color: colors.black,
  },
  tooltipContainer: {
    '& > div:first-of-type': {
      background: colors.gray,
      color: colors.white,
    },
    '& > div:last-of-type::after': {
      background: colors.gray,
    },
  },
  labelItem: {
    color: colors.black,
    fontWeight: fonts.weights.normal,
    fontSize: '0.75rem',
  },
  barLabel: {
    color: colors.chartLegend,
    fontWeight: fonts.weights.medium,
    fontSize: fonts.sizes.small,
  },
  noData: {
    display: 'grid',
    height: '100px',
    color: colors.gray,
    alignContent: 'center',
    justifyContent: 'center',
    justifyItems: 'center',
    margin: '12%',
    '& p': {
      fontSize: '1rem',
      display: 'flex',
      justifyContent: 'center',
    },
  },
});

export default useStyles;
